module.exports = __webpack_public_path__ + "static/media/aroldo-sorrindo-direita.5fbef4c7.svg";